'use strict';

require('../scss/common.scss');

import $ from 'jquery';

// This allows angular to find jQuery on the window
window.$ = $;
window.jQuery = $;

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngCookies from 'angular-cookies';

import videogular from 'videogular';
import videogularControlls from 'videogular-controls';
import videogularBuffering from 'videogular-buffering';
import videogularOverlayPlay from 'videogular-overlay-play';
import videogularThemesDefault from 'videogular-themes-default';

import angularUtilsPagination from 'angular-utils-pagination';

import infiniteScroll from 'ng-infinite-scroll';

import {core} from 'site_core';

// Our Modules
import appRoutes from './app.routes';
import appRun from './app.run';
import appDirectives from './app.directive.config.js';

'ngInject';
var app = angular.module('site', [
  angularUtilsPagination,
  uiRouter,
  ngCookies,
  core.components,
  core.features,
  core.factories,
  core.filters,
  videogular,
  videogularControlls,
  videogularBuffering,
  videogularOverlayPlay,
  infiniteScroll,
]);

app.config(['$provide', appDirectives]);
app.config(appRoutes);
app.run(appRun);

app.constant('BASE_URLS', {API: API_URL, CONTENT: CONTENT_URL});

app.constant('siteConst', {
	id: 13,
  urlShort: 'AssumeThePositionStudios.com',
  urlLong: 'http://www.AssumeThePositionStudios.com',
  urlMed: 'www.AssumeThePositionStuios.com',
  name: 'Assume The Position Studios',
  currentDate: Date.now(),
  footerTagline: '',
  logoLarge: 'images/atp_header.jpg',
  logoSmall: 'images/logo_small.png',
  warningBanner: 'images/atp_header.jpg',
  memberImage: 'images/member_video_banner.jpg',
  twoTwoFiveSevenAddress: '5400 W. 64th Ave Arvada, CO 80007',
  webmasterEmail: 'assumethepositionstudios@spanking.support',
  metaDescription: 'AssumeThePositionStudios.com - Spanking Videos and Spanking Photos, Spanking Movies, Spanking Films, Spanking Clips.  Sensual Spankings, Severe Spankings, OTK Spankings, Over the Knee Spankings, strappings, paddlings, hairbrush spankings, whipping, flogging, caning, corporal punishments, domestic discipline, fem/dom, exclusive spankings, and more!  We also have spanking video clips for sale, spanking website reviews, spanking pay-per-view movies, and the most complete spanking directory on the web.',
  tagline: {
    topLine: 'REAL HARD EXCLUSIVE SPANKING VIDEOS',
    secondLine: 'The HARD SPANKING Home of Christy Cutie and Casey Calvert. Always HARD, always on the BARE! Panties pulled down, spread for punishment with HAND, HAIRBRUSH, BELT, STRAP, CANE, and PADDLE. Hard Domestic Discipline on the delectable bare bottoms of Christy Cutie, Casey Calvert, Alex Reynolds and Maddy Marks! <a href="/join">Get Instant Access Today</a>'
  },
  footerTagline: {
    bannerDetails: '',
    getPassword: '<div class="get_password"><h4 ng-hide="$root.isMember"><a href="/join">join now to view our exclusive spankings videos!</a></h4> <p>You can buy more Clips at <a href="https://clips4sale.com/44797/assume-the-position-studios/cid9fc8f40fe6dece6bae75e817f7" target="_blank">Clip4sale</a> or on <a href="http://www.spankinglibrary.com/store/161" target="_blank">Spanking Library</a>. Always HARD, always on the BARE! Panties pulled down, spread for punishment with HAND, HAIRBRUSH, BELT, STRAP, CANE, and PADDLE.</p> </div>'
  },
  slider: {
    image: 'images/slider.jpg',
    title: 'Over 350 Videos',
    name: 'Updated 2x a Week',
    descr: 'Exclusive Videos you will not find anywhere else',
    linkText: 'instant access!'
  },
  advert: {
    tour: [
      'Authentic Bare Bottom Schoolgirl Canings',
      'Exclusive Caning Videos and Caning Pictures',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'HD/SD Mobile and Tablet Ready'
    ],
    trailer: [
      'Authentic Schoolgirl Caning',
      'Exclusive Caning Videos',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'HD/SD Mobile and Tablet Ready',
      'Classic English Caning',
      'Domestic Discipline Caning',
      'Schoolgirl Caning and Strappings',
      'Marked Ass Caning Photos'
    ]
  },
  tour: {
    updates: 12,
    models: 25,
    comingSoon: 3
  },
  join: {
    ccbill: {
      key: '642ac98a-9688-472c-9603-2180a6f7a7bd'
    },
    cco: {
      accountId: 9309,
      siteId: 23695,
      products: [
        {
          price: 29.95,
          text: '<span class="days"> 30 Day Membership <span>Rebills every 30 days at $24.95</span> </span> <span class="price"><sup>$</sup>24<sup>.95</sup></span>',
          productId: 42130
        },
        {
          price: 59.95,
          text: '<span class="days"> 90 Day Membership <span>Rebills every 90 days at $59.95</span> </span> <span class="price"><sup>$</sup>59<sup>.95</sup></span>',
          productId: 42131
        },
        {
          price: 99.95,
          text: '<span class="days"> 180 Day Membership <span>One Time Purchase - Non Recurring</span> </span> <span class="price"><sup>$</sup>99<sup>.95</sup></span>',
          productId: 42132
        }
      ]
    }
  },
  members: {
    video: {
      labels: true
    }
  }
});



// WEBPACK FOOTER //
// ./src/app/app.js